import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be585ebc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "form"
}
const _hoisted_2 = { class: "formContent" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "Sign in"
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "error-field"
}
const _hoisted_5 = {
  key: 2,
  class: "form"
}
const _hoisted_6 = { class: "formContent" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "Request new password"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "error-field"
}
const _hoisted_9 = {
  key: 3,
  class: "reset-email-sent"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please check your email to reset your password!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_LoaderCircle, { key: 0 }))
    : (_ctx.mode === 'signin')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.signinUser && _ctx.signinUser(...args)))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                placeholder: "Email",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.email]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                placeholder: "Password",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.password]
              ]),
              _hoisted_3
            ])
          ], 32),
          _createElementVNode("span", {
            class: "forgot-password",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mode = 'forgot-password'))
          }, "Forgot your password?"),
          (_ctx.error_message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error_message), 1))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.mode === 'forgot-password')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.forgotPassword && _ctx.forgotPassword(...args)))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                  placeholder: "Email",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ]),
                _hoisted_7
              ])
            ], 32),
            (_ctx.error_message)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error_message), 1))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.mode === 'reset-email-sent')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", {
                class: "forgot-password",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mode = 'signin'))
              }, "Click here to login!")
            ]))
          : _createCommentVNode("", true)
}